import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Printer, MessageCircle, Truck } from "lucide-react";
import { printDispatch, whatsappDispatch } from "@/lib/dispatch";

// Tek veya çoklu sevkiyat belgesi: kayıtlı araç/şoför atanabilir, A4 yazdır/PDF + WhatsApp.
export default function DispatchDialog({ orders, open, onClose }) {
  const list = Array.isArray(orders) ? orders : (orders ? [orders] : []);
  const [vehicles, setVehicles] = useState([]);
  const [vid, setVid] = useState("");

  useEffect(() => {
    if (!open) return;
    setVid("");
    api.get("/vehicles").then((r) => setVehicles(r.data || [])).catch(() => setVehicles([]));
  }, [open]);

  const vehicle = vehicles.find((v) => v.id === vid) || null;
  const opts = { vehicle };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="dispatch-dialog" className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading">
            <Printer className="h-5 w-5 text-brand-green" /> Sevkiyat Belgesi{list.length > 1 ? ` · ${list.length} sevkiyat` : ""}
          </DialogTitle>
          <DialogDescription>
            İsterseniz kayıtlı bir araç/şoför atayın; belgeye otomatik yazılır. Yazdırma ekranından "PDF olarak kaydet" ile WhatsApp'a ekleyebilirsiniz.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {list.length > 1 && (
            <div className="rounded-md bg-slate-50 px-3 py-2 text-xs text-slate-600 ring-1 ring-inset ring-slate-200">
              Seçili {list.length} sevkiyat tek belgede birleştirilir (kapak sayfası + her sevkiyat için ayrı fiş).
            </div>
          )}
          {vehicles.length > 0 ? (
            <div>
              <Label className="flex items-center gap-1.5"><Truck className="h-3.5 w-3.5 text-brand-green" /> Araç / Şoför (opsiyonel)</Label>
              <select data-testid="dispatch-vehicle" value={vid} onChange={(e) => setVid(e.target.value)}
                className="mt-1 h-10 w-full rounded-md border border-slate-200 bg-white px-3 text-sm">
                <option value="">— Elle doldurulacak —</option>
                {vehicles.map((v) => <option key={v.id} value={v.id}>{`${v.plate} · ${v.driver_name || "şoför?"}${v.vehicle_type ? ` · ${v.vehicle_type}` : ""}`}</option>)}
              </select>
            </div>
          ) : (
            <p className="text-xs text-slate-400">Kayıtlı araç yok — belgede şoför/araç alanları elle doldurulacak. (Lojistik → Araç Filosu'ndan ekleyebilirsiniz.)</p>
          )}
          <div className="flex gap-2">
            <Button data-testid="dispatch-do-print" onClick={() => { printDispatch(list, opts); onClose(); }} className="flex-1 bg-brand-green text-white hover:bg-brand-green-600">
              <Printer className="mr-1.5 h-4 w-4" /> Yazdır / PDF
            </Button>
            <Button data-testid="dispatch-do-wa" onClick={() => whatsappDispatch(list, opts)} variant="outline" className="border-emerald-200 text-emerald-700 hover:bg-emerald-50">
              <MessageCircle className="mr-1.5 h-4 w-4" /> WhatsApp
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
